import React, { useState, useEffect } from 'react';
import { Table, Input, Button, DatePicker, Icon } from 'antd';
import { withTranslation } from 'react-i18next';
import { getAdminLogList } from '../../axios';
import { convertUTCDateToLocalDate } from '../../utils'
import moment from 'moment';
import './index.less';

const { RangePicker } = DatePicker;

const AdminOperationLogs = (props) => {
    const { t } = props;
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [operator, setOperator] = useState('');
    const [dateRange, setDateRange] = useState([
        moment().subtract(7, 'days').startOf('day'),
        moment().endOf('day')
    ]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [isSearch, setIsSearch] = useState(false); // Used to trigger search

    useEffect(() => {
        // Fetch log data when component mounts
        getList();
    }, [page, pageSize, isSearch]);

    // Query method
    const getList = async () => {
        setLoading(true);
        const data = {
            page,
            per_page: pageSize,
            from_email: operator,
            start_time: dateRange[0] ? dateRange[0].format('YYYY-MM-DD HH:mm:ss') : undefined,
            end_time: dateRange[1] ? dateRange[1].format('YYYY-MM-DD HH:mm:ss') : undefined
        };
        const res = await getAdminLogList(data);
        setData(res.data.list);
        setTotal(res.data.totalCount);
        setLoading(false);
    };

    const columns = [
        { title: t('Operator'), dataIndex: 'from_email', key: 'from_email' },
        { title: t('Action'), dataIndex: 'resource_path', key: 'resource_path' },
        {
            title: t('CreateTime'),
            dataIndex: 'create_time',
            key: 'create_time',
            render: (text) => convertUTCDateToLocalDate(text)
        },
        {
            title: t('LoginIP'),
            key: 'login_ip',
            render: (text, record) =>
                <ul className='last-login-ip'>
                    <li>{t('LoginIP')}: {record.ip || '-'}</li>
                    <li>{t('LoginIPArea')}: {record.ip_area || '-'}</li>
                    <li>{t('LoginIPAreaCode')}: {record.ip_area_code || '-'}</li>
                </ul>
        },
        {
            title: t('Result'),
            key: 'result',
            render: (text, record) =>
                record.result === 0 ? <span style={{ color: '#52c41a' }}>{t('Success')}</span> : <span style={{ color: '#f5222d' }}>{t('Failed')}</span>
        }
    ];

    const pageChange = (page, pageSize) => {
        setPage(page);
        setPageSize(pageSize);
    }

    const handleSearch = () => {
        setPage(1); // Reset page number
        setIsSearch(!isSearch); // Trigger search
    }

    return (
        <div className='main-new'>
            <div className="main-cotent">
                <div className="logs-cotent">
                    <div className='logs-search' style={{ display: 'flex', gap: 12 }}>
                        <Input
                            style={{ width: 200 }}
                            placeholder={t('Operator')}
                            value={operator}
                            onChange={e => setOperator(e.target.value)}
                            prefix={<Icon type="user" />}
                        />
                        <RangePicker
                            style={{ width: 300 }}
                            value={dateRange}
                            showTime={{ format: 'HH:mm:ss', defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }}
                            format="YYYY-MM-DD HH:mm:ss"
                            onChange={dates => {
                                if (dates && dates.length === 2 && dates[0] && dates[1]) {
                                    // If the same day, complete hours, minutes, and seconds
                                    if (dates[0].isSame(dates[1], 'day')) {
                                        setDateRange([
                                            dates[0].clone().startOf('day'),
                                            dates[1].clone().endOf('day')
                                        ]);
                                    } else {
                                        setDateRange(dates);
                                    }
                                } else {
                                    setDateRange(dates);
                                }
                            }}
                            allowClear
                        />
                        <Button type="primary" onClick={handleSearch}>{t('Search')}</Button>
                        <Button style={{ marginLeft: 4 }} onClick={() => {
                            setOperator('');
                            setDateRange([
                                moment().subtract(7, 'days').startOf('day'),
                                moment().endOf('day')
                            ]);
                            setPage(1);
                            setIsSearch(!isSearch); // Trigger search
                        }}>{t('Clear')}</Button>
                    </div>
                    <Table
                        rowKey={record => record.id}
                        size='small'
                        columns={columns}
                        dataSource={data}
                        loading={loading}
                        pagination={{ current: page, pageSize: pageSize, total: total, onChange: pageChange }}
                        locale={{ emptyText: t('NoData') }}
                    />
                </div>
            </div>
        </div>
    );
};

export default withTranslation(['common'])(AdminOperationLogs);
